<div class="file-list">
  <div *ngIf="status === 'success'">
    <ul>
      @for (file of files; track file.id) {
        <li>
          <button
            (click)="downloadService.downloadFile(file.id, file.name).subscribe()"
            [attr.aria-label]="normalize(file.description) + ' Herunterladen'">
            <span class="file-name">{{ normalize(file.description) }}</span>
            <svg-icon src="assets/images/icons/download_arrow.svg" class="file-icon"></svg-icon>
          </button>
        </li>
      }
    </ul>
  </div>

  <div *ngIf="status === 'error'">
    <h2>Fehler beim Abrufen der Dateien!</h2>
  </div>
</div>
